export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 p-8 md:p-12 rounded-2xl bg-gradient-to-br from-primary-500/10 via-accent-500/5 to-background-100 border border-primary-500/15">
            <div className="flex-shrink-0">
              <div className="w-28 h-28 md:w-36 md:h-36 flex items-center justify-center rounded-3xl bg-primary-500/15 border border-primary-500/25">
                <i className="ri-smartphone-line text-5xl md:text-6xl text-primary-400"></i>
              </div>
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-100 font-heading mb-3">
                APP下载
              </h2>
              <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-[480px] mx-auto lg:mx-0">
                日皮视频移动客户端即将上线，支持蜜桃视频、红桃视频、香蕉视频、樱花视频等全频道内容一键直达。
                高清流畅播放，离线缓存，个性化的推荐算法，让你随时随地畅享优质视频内容。敬请期待正式版本发布。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#contact"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="inline-flex items-center gap-2 px-6 py-3 bg-background-200/80 hover:bg-background-300/80 text-foreground-200 font-medium text-sm rounded-lg border border-background-300/60 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-line text-lg"></i>
                  iOS 即将上线
                </a>
                <a
                  href="#contact"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="inline-flex items-center gap-2 px-6 py-3 bg-background-200/80 hover:bg-background-300/80 text-foreground-200 font-medium text-sm rounded-lg border border-background-300/60 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-line text-lg"></i>
                  Android 即将上线
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}